import React from "react";
import { AuthContext } from "../../Types/AuthContext";
import { Navigate, useLocation } from "react-router-dom";


interface AuthProtectedProps {
    permissions: string[];
    children?: React.ReactNode;
}


export default function AuthProtected(props: AuthProtectedProps) {
    const location = useLocation();
    const { permissions } = React.useContext(AuthContext);

    if (props.permissions.some(p => permissions.includes(p))) {
        return (<>{props.children}</>);
    } else {
        return (<Navigate to="/login" state={{from: location}} replace />);
    }
}